import React from 'react';
import { Props } from '../../types';
import { Container } from '../../styles';
import { ROLE } from '../../../../utils/roles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { orange, blue, green, red } from '../../index';

const Status: React.FC<Props> = ({ acronym }) => {
  let text = React.useRef('');
  let color = React.useRef('');
  const perfil = useSelector((state: ApplicationState) => state?.auth?.user?.perfil);

  switch (acronym) {
    case 'AA':
      text.current = 'Aguardando atendimento';
      color.current = orange;
      break;

    case 'EA':
      text.current = 'Em atendimento';
      color.current = blue;
      break;

    case 'AC':
      text.current = 'Atendimento concluído';
      color.current = green;
      break;

    case 'ARC':
      text.current = 'Aguardando retorno do cliente';
      color.current = red;
      break;

    case 'ARI':
      if (perfil === ROLE.ADMINISTRADOR || perfil === ROLE.ANALISTACD) {
        text.current = 'Aguardando retorno interno';
        color.current = red;
        break;
      }
      text.current = 'Em atendimento';
      color.current = blue;
      break;

    default:
      color.current = '#777';
      text.current = 'Sem informações de status';
      break;
  }

  return (
    <Container data-cy="statusAtendimento" color={color.current} style={{ textAlign: 'center' }}>
      {text.current}
    </Container>
  );
};

export default Status;
